{
  "schemaVersion": "1.0.0",
  "scenarioId": "dependency-down",
  "payload": {
    "records": [
      { "id": 1, "full_name": "Sofía Peña", "email": "sofia.pena@example.com", "signup_date": "2024-06-01" },
      { "id": 2, "full_name": "Hugo Campos", "email": "hugo.campos@example.com", "signup_date": "2024-06-02" }
    ]
  },
  "options": { "deterministic": false }
}
